<h1 mat-dialog-title>Tiere filtern</h1>

<p *ngIf="info">{{ info }}</p>

<div mat-dialog-content>
    <kiene-gruppe-tier-filter
        (selectedFilter)="setFilter($event)"
        *ngIf="!!filterSettings?.showFilter"
        [disabledFilters]="disabledTierFilterOptions"
        [filter]="this.filterSettings.filter"
    >
    </kiene-gruppe-tier-filter>

    <kiene-gruppe-tier-abteil-filter
        (selectedAbteile)="filterSettings.abteile = $event || []"
        *ngIf="!!filterSettings?.showAbteile"
        [abteile]="filterSettings.abteile"
        [gruppeId]="this.gruppe?.gruppe_id"
        [gruppeIds]="gruppeIds"
        >
    </kiene-gruppe-tier-abteil-filter>

    <kiene-gruppe-tier-abgangsliste-filter
        (selectedAbgangslisten)="filterSettings.abgangslisten = $event || []"
        *ngIf="!!filterSettings?.showAbgangslisten"
        [abgangslisten]="filterSettings.abgangslisten"
        [gruppe]="this.gruppe"
        [mitAbgangsgewicht]="showAbgangsgewichtInfo"
    >
    </kiene-gruppe-tier-abgangsliste-filter>

    <kiene-gruppe-tier-reklamation-filter
        (selectedReklamationen)="filterSettings.reklamationen = $event || []"
        *ngIf="!!filterSettings?.showReklamationen"
        [gruppeId]="this.gruppe?.gruppe_id"
        [gruppeIds]="gruppeIds"
        [reklamationen]="filterSettings.reklamationen"
    >
    </kiene-gruppe-tier-reklamation-filter>

    <kiene-gruppe-tier-rasse-filter
        (selectedRassen)="filterSettings.rassen = $event || []"
        *ngIf="!!filterSettings?.showRassen"
        [gruppe]="this.gruppe"
        [gruppeIds]="gruppeIds"
        [rassen]="filterSettings.rassen"
    >
    </kiene-gruppe-tier-rasse-filter>

    <kiene-gruppe-tier-geschlecht-filter
        (selectedGeschlechter)="filterSettings.geschlechter = $event || []"
        *ngIf="!!filterSettings?.showGeschlechter"
        [gruppe]="this.gruppe"
        [gruppeIds]="gruppeIds"
        [geschlechter]="filterSettings.geschlechter"
    >
    </kiene-gruppe-tier-geschlecht-filter>

    <kiene-gruppe-tier-viehhaendler-filter
        #filterViehhaendler
        (selectedHaendler)="viehhaendlerSelected($event)"
        *ngIf="!!filterSettings?.showViehhaendler"
        [filter]="filterSettings"
        [gruppe]="this.gruppe"
        [gruppeIds]="gruppeIds"
        [haendler]="filterSettings.viehhaendler"
        [mitEinstallgewicht]="showEinstallgewichtInfo"
    >
    </kiene-gruppe-tier-viehhaendler-filter>

    <div
        *ngIf="
            filterSettings?.showViehhaendler &&
            filterSettings?.showBetriebskontakte &&
            filterSettings?.viehhaendler?.length === 0 &&
            filterSettings?.betriebskontakte?.length === 0
        "
        style="text-align: center; margin: 8px 0; font-weight: bold; color: #666"
    >
        Oder
    </div>

    <div *ngIf="filterSettings?.showBetriebskontakte" style="margin-top: 12px">
        <div *ngIf="filterSettings?.betriebskontakte?.length > 0">
            <kiene-betriebskontakt-card
                [kontakt]="filterSettings?.betriebskontakte[0]"
                [config]="betriebskontaktCardConfig"
                (entfernen)="betriebskontaktEntfernen()"
            >
            </kiene-betriebskontakt-card>
        </div>

        <div *ngIf="filterSettings?.betriebskontakte?.length === 0">
            <!-- Keep list mounted while refreshing so selection clicks are not destroyed mid-click. -->
            <div class="kontakt-loading" *ngIf="isLoadingBetriebskontakte && !(betriebskontakteFuerGruppe?.length > 0)">
                <mat-spinner diameter="24"></mat-spinner>
                <span>Lade passende Betriebskontakte …</span>
            </div>

            <div [class.kontakt-list-busy]="isLoadingBetriebskontakte && betriebskontakteFuerGruppe?.length > 0">
                <kiene-betriebskontakt-auswahl
                    *ngIf="betriebskontakteFuerGruppe?.length > 0"
                    [config]="betriebskontaktFilterConfig"
                    [kontakteOverride]="betriebskontakteFuerGruppe"
                    [selectedKontakte]="filterSettings?.betriebskontakte"
                    (kontaktSelected)="betriebskontaktSelected($event)"
                >
                </kiene-betriebskontakt-auswahl>
            </div>

            <div
                class="kontakt-empty"
                *ngIf="!isLoadingBetriebskontakte && betriebskontakteFuerGruppe?.length === 0"
            >
                <span>Keine passenden Betriebskontakte mit eingestallten Tieren gefunden.</span>
            </div>
        </div>
    </div>

    <kiene-gruppe-tier-einstalldatum-filter
        #filterEinstalldatum
        (change)="einstalldatumSelected($event)"
        *ngIf="!!filterSettings?.showEinstalldatum"
        [einstalldaten]="filterSettings.einstalldatum"
        [filter]="filterSettings"
        [gruppe]="gruppe"
        [gruppeIds]="gruppeIds"
        [mitEinstallgewicht]="showEinstallgewichtInfo"
    ></kiene-gruppe-tier-einstalldatum-filter>

    <kiene-gruppe-tier-herkunft-filter
        (selectedHerkunftsbetriebe)="filterSettings.herkunftsbetriebe = $event || []"
        *ngIf="!!filterSettings?.showHerkunftsbetriebe"
        [gruppeId]="this.gruppe?.gruppe_id"
        [gruppeIds]="gruppeIds"
        [herkunftsbetriebe]="filterSettings.herkunftsbetriebe"
    >
    </kiene-gruppe-tier-herkunft-filter>
</div>

<div mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <mat-checkbox
        *ngIf="showSaveFilterOption"
        [formControl]="saveFilterCtrl"
        class="save-filter-checkbox"
    >
        Filter speichern
    </mat-checkbox>
    <span class="spacer"></span>
    <button (click)="delete()" color="accent" mat-flat-button>Filter löschen</button>
    <button (click)="apply()" color="accent" mat-flat-button>Anwenden</button>
</div>
